export const AM_REWARDS_CARDS_IMAGES = {
  'CLASSIC' : '/cms/sites/default/files/tarjeta-Classic.png',
  'CA' : '/cms/sites/default/files/tarjeta-EagleKnight.png',
  'CABALLEROAGUILA' : '/cms/sites/default/files/tarjeta-EagleKnight.png',
  'EagleKnight' : '/cms/sites/default/files/tarjeta-EagleKnight.png',
  'TTP' : '/cms/sites/default/files/tarjeta-EagleKnight.png',
  'GOLD' : '/cms/sites/default/files/tarjeta-Gold.png',
  'GLD' : '/cms/sites/default/files/tarjeta-Gold.png',
  'PLATINUM' : '/cms/sites/default/files/tarjeta-Platinum.png',
  'PLT' : '/cms/sites/default/files/tarjeta-Platinum.png',
  'SILVER' : '/cms/sites/default/files/tarjeta-Silver.png',
  'SLV' : '/cms/sites/default/files/tarjeta-Silver.png',
  'TITANIUM' : '/cms/sites/default/files/tarjeta-Titanium.png',
  'TTN' : '/cms/sites/default/files/tarjeta-Titanium.png',
};

const COBRANDED_CARDS_ID = {
  'SEIFNT' : 'SANTANDER_INFINITE',
  'SEPLAT' : 'SANTANDER_PLATINUM',
  'SECLAS' : 'SANTANDER_BLANCA',
  'AMXPLT' : 'AMEX_PLATINUM',
  'AMXGLD' : 'AMEX_GOLD',
  'AMXGRN' : 'AMEX_BLUE',
};

export const COBRANDED_CARDS_IMAGES = {
  'SECLAS' : '/cms/sites/default/files/SECLAS.png',
  'SEPLAT' : '/cms/sites/default/files/SEPLAT.png',
  'SEIFNT' : '/cms/sites/default/files/SEIFNT.png',
  'AMXPLT' : '/cms/sites/default/files/AMXPLT.png',
  'AMXGLD' : '/cms/sites/default/files/AMXGLD.png',
  'AMXGRN' : '/cms/sites/default/files/AMXGRN.png',
};


const COBRANDED_CARDS_NAMES = {
  'SEIFNT' : 'Santander Infinite',
  'SEPLAT'  : 'Santander Platinum',
  'SECLAS' : 'Santander Aeromexico',
  'AMXPLT' : 'Platinum Amex Aeromexico',
  'AMXGLD' : 'Gold Amex Aeromexico',
  'AMXGRN' : 'Amex Aeromexico',
};

const ENROLLMENT_ABORT_ERRORS = [
  'ERR.UB.ENROLLMENT.TERMS_AND_CONDITIONS',
  'ERR.UB.ENROLLMENT.UNKNOWN',
  'ERR.UB.ENROLLMENT.CRIS_TIMEOUT',
  'ERR.UB.ENROLLMENT.DUPLICATE_RECORD',
  'ERR.UB.ENROLLMENT.INVALID_REQUEST',
  'ERR.UC.ENROLLMENT.OTP_SERVICE_NOTAVAILABLE',
  'ERR.UC.ENROLLMENT.SERVICE_NOTAVAILABLE',
  'ERR.UC.OTP.SERVICE_NOTAVAILABLE',
  'ERR.UC.OTP.TIMEOUT',
  'ERR.UC.SENDOTP.SENDING_FAILED',
  'ERR.UC.VALIDATEOTP.VALIDATION_FAILED',
  'ERR.UC.OTP.INVALID_REQUEST',
  'ERR.UC.OTP.OTP_SERVICE_NOTAVAILABLE',
  'ERR.UC.OTP.NOTIFICATION_SERVICE_NOTAVAILABLE',
  'ERR.UC.OTP.EMAIL_SEND_FAILED',
  503,
];

const ENROLLMENT_RETRY_ERRORS = [
  'ERR.UB.ENROLLMENT.INVALID_GUARDIAN_CARD',
  'ERR.UB.ENROLLMENT.INVALID_GUARDIAN_EMAIL',
  'ERR.UB.ENROLLMENT.INVALID_MEDIA_CODE',
  'ERR.UB.ENROLLMENT.MINOR_ENROLLMENT',
];

export {
  ENROLLMENT_ABORT_ERRORS,
  ENROLLMENT_RETRY_ERRORS,
};

export default {
  AM_REWARDS_CARDS_IMAGES,
  COBRANDED_CARDS_IMAGES,
  COBRANDED_CARDS_ID,
  COBRANDED_CARDS_NAMES,
};
